module.exports = __webpack_public_path__ + "img/Paul Sanford.3d09803a.jpg";